import axios from 'axios';
import Cookies from 'js-cookie';
import Config from '../../config';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import { fetchBrandMaster } from '../brandMaster/brandMaster.actions';
import { fetchProductMasterData } from '../product/product.action';
import { fetchSizeInfoData } from '../sizeInfo/sizeInfo.actions';
import { fetchStyleMaster } from '../styleMaster/styleMaster.actions';
import {
    FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_REQUEST,
    FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_SUCCESS,
    FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_FAILURE,
    CREATE_SIZE_MEASUREMENT_MASTER_FORM,
    FETCH_SIZE_MEASUREMENT_MASTER_REQUEST,
    FETCH_SIZE_MEASUREMENT_MASTER_SUCCESS,
    FETCH_SIZE_MEASUREMENT_MASTER_FAILURE,
    CREATE_SIZE_MEASUREMENT_MASTER_REQUEST,
    CREATE_SIZE_MEASUREMENT_MASTER_SUCCESS,
    CREATE_SIZE_MEASUREMENT_MASTER_FAILURE,
    RESET_SIZE_MEASUREMENT_MASTER_INFO,
    UPDATE_SIZE_MEASUREMENT_MASTER_REQUEST,
    UPDATE_SIZE_MEASUREMENT_MASTER_SUCCESS,
    UPDATE_SIZE_MEASUREMENT_MASTER_FAILURE,
    DELETE_SIZE_MEASUREMENT_MASTER_REQUEST,
    DELETE_SIZE_MEASUREMENT_MASTER_SUCCESS,
    DELETE_SIZE_MEASUREMENT_MASTER_FAILURE,
    FETCH_ALL_SIZES_REQUEST,
    FETCH_ALL_SIZES_SUCCESS,
    FETCH_ALL_SIZES_FAILURE,
    FETCH_ALL_BUYER_REQUEST,
    FETCH_ALL_BUYER_SUCCESS,
    FETCH_ALL_BUYER_FAILURE
} from './sizeMeasurementMaster.actionsType';

// FETCH SIZE MEASUREMENT MASTER DATA
export let fetchSizeMeasurementMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.sizeMeasurementMasterGET,
        responseTypeRequest: FETCH_SIZE_MEASUREMENT_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SIZE_MEASUREMENT_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SIZE_MEASUREMENT_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE SIZE MEASUREMENT MASTER FORM
export let createSizeMeasurementMasterForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_SIZE_MEASUREMENT_MASTER_FORM, payload: { key, value } });
    };
};

// CREATE SIZE MEASUREMENT MASTER
export let createSizeMeasurementMaster = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        fldGroupCode: '',
        ...formData,
        fldPrint: formData.fldPrint ? formData.fldPrint : '',
        fldFKSizeinfo: parseInt(formData.fldFKSizeinfo),
        fldFKBuyerMaster: formData.fldFKBuyerMaster ? parseInt(formData.fldFKBuyerMaster) : 0,
        fldFKstyleMaster: formData.fldFKstyleMaster ? parseInt(formData.fldFKstyleMaster) : 0,
        fldFKBrandMaster: formData.fldFKBrandMaster ? parseInt(formData.fldFKBrandMaster) : 0,
        fldFKProductList: parseInt(formData.fldFKProductList)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.sizeMeasurementMasterPOST}`,
        responseTypeRequest: CREATE_SIZE_MEASUREMENT_MASTER_REQUEST,
        responseTypeSuccess: CREATE_SIZE_MEASUREMENT_MASTER_SUCCESS,
        responseTypeFailure: CREATE_SIZE_MEASUREMENT_MASTER_FAILURE,
        resetFormData: RESET_SIZE_MEASUREMENT_MASTER_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSizeMeasurementMaster()
    };
    return axiosCall(config);
};

// GET SINGLE SIZE MEASUREMENT MASTER
export let getSingleSizeMeasurementMaster = (id) => {
    return (dispatch) => {
        dispatch({ type: FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_REQUEST });
        var config = {
            method: 'get',
            url: `${Config.baseUrl}/api/TblSizeMeasurementHeader/GetTblSizeMeasurementHeader/${id}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };
        axios(config)
            .then((response) => {
                dispatch({ type: FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_SUCCESS, payload: response.data });
                dispatch(fetchSizeInfoData());
                dispatch(fetchSizeList(parseInt(response?.data?.fldFKSizeinfo)));
                dispatch(fetchProductMasterData());
                dispatch(fetchBrandMaster());
                dispatch(fetchStyleMaster());
                dispatch(fetchBuyerList());
            })
            .catch((error) => {
                dispatch({ type: FETCH_SINGLE_SIZE_MEASUREMENT_MASTER_FAILURE, payload: error });
            });
    };
};

//UPDATE SIZE MEASUREMENT MASTER
export let updateSizeMeasurementMaster = (formData) => {
    let today = new Date();
    let data = {
        ...formData,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString(),
        fldPrint: formData.fldPrint ? formData.fldPrint : '',
        fldFKSizeinfo: parseInt(formData.fldFKSizeinfo),
        fldFKBuyerMaster: formData.fldFKBuyerMaster ? parseInt(formData.fldFKBuyerMaster) : 0,
        fldFKstyleMaster: formData.fldFKstyleMaster ? parseInt(formData.fldFKstyleMaster) : 0,
        fldFKBrandMaster: formData.fldFKBrandMaster ? parseInt(formData.fldFKBrandMaster) : 0,
        fldFKProductList: parseInt(formData.fldFKProductList)
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.sizeMeasurementMasterPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_SIZE_MEASUREMENT_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_SIZE_MEASUREMENT_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_SIZE_MEASUREMENT_MASTER_FAILURE,
        resetFormData: RESET_SIZE_MEASUREMENT_MASTER_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchSizeMeasurementMaster()
    };
    return axiosCall(config);
};

// DELETE SIZE MEASUREMENT MASTER
export let deleteSizeMeasurement = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.sizeMeasurementMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_SIZE_MEASUREMENT_MASTER_REQUEST,
        responseTypeSuccess: DELETE_SIZE_MEASUREMENT_MASTER_SUCCESS,
        responseTypeFailure: DELETE_SIZE_MEASUREMENT_MASTER_FAILURE,
        resetFormData: RESET_SIZE_MEASUREMENT_MASTER_INFO,
        modalClose: true,
        getAllData: fetchSizeMeasurementMaster()
    };
    return axiosCall(config);
};

// FETCH SIZE ALL SIZES
export let fetchSizeList = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.sizeInfoIdGET}/${id}`,
        responseTypeRequest: FETCH_ALL_SIZES_REQUEST,
        responseTypeSuccess: FETCH_ALL_SIZES_SUCCESS,
        responseTypeFailure: FETCH_ALL_SIZES_FAILURE
    };
    return axiosCall(config);
};

// FETCH SIZE ALL BUYER
export let fetchBuyerList = () => {
    let config = {
        method: 'get',
        url: ConstantApi.sizeMeasurementBuyerList,
        responseTypeRequest: FETCH_ALL_BUYER_REQUEST,
        responseTypeSuccess: FETCH_ALL_BUYER_SUCCESS,
        responseTypeFailure: FETCH_ALL_BUYER_FAILURE
    };
    return axiosCall(config);
};
